import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {DeltaVolumiService} from '../../monthly-actual/delta-volumi/service-delta-volumi/delta-volumi.service';
import {Subscription} from 'rxjs';
import * as toastr from 'toastr';
import {ProjectConstants} from '../../project-constants';
import {Router} from '@angular/router';
import {DeltaChargesService} from '../../monthly-charges/delta-charges/service-delta-charges/delta-charges.service';
import {ConsuntivoVolumiService} from '../../monthly-actual/consuntivo-volumi/service-consuntivo-volumi/consuntivo-volumi.service';
import {ConsuntivoChargesService} from '../../monthly-charges/consuntivo-charges/service-consuntivo-charges/consuntivo-charges.service';

@Component({
  selector: 'app-dialog-detail',
  templateUrl: './dialog-detail.component.html',
  styleUrls: ['./dialog-detail.component.scss']
})
export class DialogDetailComponent extends ProjectConstants implements OnInit {

  dataValues: Array<any>;
  showNotes: boolean;
  idNotes: number;
  updateNotes: Subscription;
  note: any;
  data: any;

  constructor(public dialogData: MatDialogRef<DialogDetailComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private router: Router,
              private consuntivoVolumiService: ConsuntivoVolumiService,
              private consuntivoChargesService: ConsuntivoChargesService,
              private deltaVolumiService: DeltaVolumiService,
              private deltaChargesService: DeltaChargesService) {
      super();
      this.dataValues = data.list;
      this.showNotes = false;
      if (data.note) {
        this.showNotes = true;
        this.note = data.list[0].value ;
        this.idNotes = data.discountData.id;
        this.data = data.serviceType;
      }
  }

  ngOnInit() {
  }

  save() {
    const noteObj = new Notes(this.idNotes, this.note);
    if (this.data === 'volume') {
      this.updateNotes = this.consuntivoVolumiService.update(this.consuntivoVolumiService.baseUrl, {id: this.idNotes, notes: this.note})
        .subscribe(
          (result: any) => {
            toastr.success('Note updated with success', 'Success');
            this.dialogData.close();
          }, error => {
            toastr.error('A problem has occurred, please contact the Administrator', 'Error');
          }
        );
    } else if (this.data === 'charges') {
      this.updateNotes = this.consuntivoChargesService.update(this.consuntivoChargesService.baseUrl, {id: this.idNotes, notes: this.note})
        .subscribe(
          (result: any) => {
            toastr.success('Note update with success', 'Success');
            this.dialogData.close();
          }, error => {
            toastr.error('A problem has occurred, please contract the Administrator', 'Error');
          }
        );
    } else if (this.data === 'delta_volume') {
      this.updateNotes = this.deltaVolumiService.update(this.deltaVolumiService.baseUrl, noteObj)
        .subscribe(
          (result: any) => {
            toastr.success('Note updated with success', 'Success');
            this.dialogData.close();
          }, error => {
            toastr.error('A problem has occurred, please contact the Administrator', 'Error');
          }
        );
    } else if (this.data === 'delta_charges') {
      this.updateNotes = this.deltaChargesService.update(this.deltaChargesService.baseUrl, noteObj)
        .subscribe(
          (result: any) => {
            toastr.success('Note updated with success', 'Success');
            this.dialogData.close();
          }, error => {
            toastr.error('A problem has occurred, please contact the Administrator', 'Error');
          }
        );
    }

  }

  close() {
    this.dialogData.close();
  }

}

export class Notes {
  id: number;
  note: string;

  constructor(id: number, note: string) {
    this.id = id;
    this.note = note;
  }
}
